/**
 * Ein gerendertes Vertragsblatt, abgeschirmt vom App-Stylesheet.
 *
 * Herausgelöst aus `VertragVorschau.tsx`, als die zweite Vorschau dazukam: der
 * Klauselwerk-Editor zeigt den Text am Beispielkunden, die Vertragsakte zeigt
 * den echten Vertrag. Beide sollen dasselbe Blatt malen — zwei Kopien dieser
 * Datei wären zwei Dokumente, die langsam auseinanderlaufen.
 *
 * `vertrag.css` gehört einem A4-Dokument. Ohne Abschirmung setzte es die
 * Schriftgrößen und Tabellen der ganzen Pflege-App um — und umgekehrt sähe der
 * Vertrag in der Vorschau anders aus als im PDF, was den Zweck der Vorschau
 * gerade aufhebt.
 */

// `all: initial` macht aus dem Wirt ein inline-Element — ohne das
// display:block bekäme das Blatt keine Breite. Die Schrift ist eine Serife,
// weil der gedruckte Vertrag eine trägt; eine Vorschau in der App-Schrift
// beantwortet die Frage „sieht das gut aus" für ein anderes Dokument.
const RAHMEN = `
  :host { all: initial; display: block; }
  .blatt {
    font-family: Georgia, "Times New Roman", serif;
    /* Wächst mit der Spalte. Fest gesetzte 10.5pt sahen in einer breiten
       Spalte klein und in einer schmalen gedrängt aus — der Blocksatz des
       Vertrages verzeiht beides schlecht. */
    font-size: clamp(10.5pt, 0.95vw, 12.5pt);
    line-height: 1.5; color: #1a1a1a;
    background: #fff;
    padding: clamp(20px, 4.5%, 56px);
  }
`;

// Bewusst KEINE Silbentrennung hier. Der Blocksatz des Vertrages reißt in
// schmalen Spalten Löcher zwischen die Wörter, und `hyphens: auto` würde das
// mildern — aber `vertrag.css` kennt die Regel nicht, also hätte das PDF sie
// nicht. Eine Vorschau, die schöner setzt als das Dokument, beantwortet die
// Frage „wie sieht das beim Kunden aus" falsch. Gegen die Löcher hilft Breite,
// und die gibt es jetzt.

export default function VertragBlatt({ css, html }: { css: string; html: string }) {
  return (
    <div className="vt-blatt">
      <div
        ref={el => {
          if (!el) return;
          const wurzel = el.shadowRoot || el.attachShadow({ mode: "open" });
          wurzel.innerHTML =
            "<style>" + RAHMEN + css + "</style>" +
            '<div class="blatt">' + html + "</div>";
        }}
      />
    </div>
  );
}
